// extracted by mini-css-extract-plugin
module.exports = {"form":"HandlerIndexForm_form__1EqlO","checks":"HandlerIndexForm_checks__3y1K4","actions":"HandlerIndexForm_actions__2uflT"};